import Dealer from './dealer';

export const dealer = {
  firstLevel: Dealer,
};